export default __webpack_public_path__ + "static/media/IOSCalculater.651010a3.gif";